// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"747":"6ad8096ec8a398a5","3972":"f719af9b5c927815"}[chunkId] + ".css";
};